import { useMutation, useQueryClient } from 'react-query';

interface UpdateCardStatusProps {
  uuid: string;
  status: 'reactivate' | 'suspend';
}

const useUpdateWalletCardStatus = ({
  updateQuery,
  queryName,
  onSuccess,
  onError
}: {
  updateQuery: (uuid: string, status: { status: 'reactivate' | 'suspend' }) => Promise<string>;
  queryName: string;
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}) => {
  const queryClient = useQueryClient();

  const updateCardStatusMutation = useMutation(
    async ({ uuid, status }: UpdateCardStatusProps): Promise<string> => {
      try {
        const data = await updateQuery(uuid, { status });
        return data;
      } catch (error) {
        throw error;
      }
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(queryName);
        queryClient.removeQueries('card');

        if (onSuccess) {
          onSuccess();
        }
      },
      onError: async (error: Error) => {
        if (onError) {
          onError(error);
        }
      }
    }
  );

  return updateCardStatusMutation;
};

export default useUpdateWalletCardStatus;
